import { render } from "./PrevNextButton.vue?vue&type=template&id=5c0bd9ba&scoped=true&ts=true"
import script from "./PrevNextButton.vue?vue&type=script&lang=ts"
export * from "./PrevNextButton.vue?vue&type=script&lang=ts"

import "./PrevNextButton.vue?vue&type=style&index=0&id=5c0bd9ba&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c0bd9ba"]])

export default __exports__